'use client';

import { c as _c } from "react/compiler-runtime";
import { NativeSelect as Select } from '@chakra-ui/react';
import { forwardRef, useMemo } from 'react';
interface NativeSelectRootProps extends Select.RootProps {
  icon?: React.ReactNode;
}
export const NativeSelectRoot = forwardRef<HTMLDivElement, NativeSelectRootProps>(function NativeSelect(props, ref) {
  const $ = _c(11);
  let children;
  let icon;
  let rest;
  if ($[0] !== props) {
    ({
      icon,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = icon;
    $[3] = rest;
  } else {
    children = $[1];
    icon = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== icon) {
    t0 = <Select.Indicator>{icon}</Select.Indicator>;
    $[4] = icon;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t0) {
    t1 = <Select.Root ref={ref} {...rest}>{children}{t0}</Select.Root>;
    $[6] = children;
    $[7] = ref;
    $[8] = rest;
    $[9] = t0;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
});
interface NativeSelectItem {
  value: string;
  label: string;
  disabled?: boolean;
}
interface NativeSelectField extends Select.FieldProps {
  items?: Array<string | NativeSelectItem>;
}
export const NativeSelectField = forwardRef<HTMLSelectElement, NativeSelectField>(function NativeSelectField(props, ref) {
  const $ = _c(13);
  let children;
  let itemsProp;
  let rest;
  if ($[0] !== props) {
    ({
      items: itemsProp,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = itemsProp;
    $[3] = rest;
  } else {
    children = $[1];
    itemsProp = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== itemsProp) {
    t0 = itemsProp?.map(_temp);
    $[4] = itemsProp;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const items = t0;
  let t1;
  if ($[6] !== items) {
    t1 = items?.map(_temp2);
    $[6] = items;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== ref || $[10] !== rest || $[11] !== t1) {
    t2 = <Select.Field ref={ref} {...rest}>{children}{t1}</Select.Field>;
    $[8] = children;
    $[9] = ref;
    $[10] = rest;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
});
function _temp(item) {
  return typeof item === "string" ? {
    label: item,
    value: item
  } : item;
}
function _temp2(item_0) {
  return <option key={item_0.value} value={item_0.value} disabled={item_0.disabled}>{item_0.label}</option>;
}